export const widgetsConfig = {
    rightColumnConf: {
        pageSetup: {
            tabs: false,
            signUp: true,
        },
    },
    desktopPoint: {
        width: 1280,
    },
};
